import React from 'react';
import './Garantia.css';
import GarantiaImg from '../../assets/imgs/Garantia.png';
function Garantia() {
  return (
    <div className='garantia-container'>
      <div><img alt='insigne' src={GarantiaImg}></img></div>
      <div>
        <h4>RISCO ZERO</h4>
        <h2>Garantia incondicional de 7 dias</h2>
        <p>Em 7 dias, você pode usar nossa plataforma à vontade. Consuma tudo que tem lá dentro e, se acreditar que ela não é para você nesse período, devolveremos seu dinheiro todo, sem burocracia.</p>
      </div>
    </div>
  );
}

export default Garantia;
